import React, { useContext } from 'react';
import { TableContext } from '../../contexts/TableContext';
import HeadCell from './HeadCell';

const TableHead: React.FC = () => {
  const { headCells } = useContext(TableContext);

  const cells = headCells.map((cell) => {
    return <HeadCell key={cell.id} cell={cell} />;
  });

  return (
    <thead>
      <tr>{cells}</tr>
    </thead>
  );
};

export default TableHead;
